import React, { useState } from 'react'
import Slide from '@mui/material/Slide';
import Button from '@mui/material/Button';
import ReorderIcon from '@mui/icons-material/Reorder';
import NavMenu from '../../../components/NavMenu/NavMenu';
import useScreenWidth from '../../../store/useScreenWidth';
import { useExpandNavMenu } from '../../../store/useExpandNavMenu';
import { useDarkModeStore } from '../../../store/useDarkModeStore';

export const NavMenuMobile = () => {
    const isSmallScreen = useScreenWidth();

    const { darkMode } = useDarkModeStore();
    const { setIsCollapsed } = useExpandNavMenu();

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setIsCollapsed(false);
        setAnchorEl(null);
    };

    return <React.Fragment>
        <Button
            className="button-hover-circle"
            style={{ background: 'rgba(50, 71, 92, 0.04)', borderRadius: '50%' }}
            variant="text"
            onClick={handleClick}
        >
            <ReorderIcon
                className='icon-sidebar-top-color'
                sx={{ width: '22px', height: '22px', color: darkMode ? 'white' : '#4D5F71' }}
            />
        </Button>
        <Slide
            direction="down"
            in={!!anchorEl}
            timeout={100}
            mountOnEnter
            unmountOnExit
        >
            <div
                className='position-absolute w-100'
                style={{ top: isSmallScreen ? '-37px' : 0, left: isSmallScreen ? '-7px' : 0 }}
            >
                <NavMenu isMobile handleClose={handleClose} />
            </div>
        </Slide>
    </React.Fragment>
}
export default NavMenuMobile